import { render, staticRenderFns } from "./JudgeInfoModal.vue?vue&type=template&id=7aa0bd17&scoped=true&"
import script from "./JudgeInfoModal.vue?vue&type=script&lang=js&"
export * from "./JudgeInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0bd17",
  null
  
)

export default component.exports